import * as types from '../types/types';

const initialState = {
  dashboardMaterials: false,
  allProject: false,
  myProject: false,
  allTasks: false,
  myTasks: false,
  dsbp: false,
  projectPlan: false,
  changeHandling: false,
  changeHandlingHistory: false,
  artworkScopeAlignment: false,
  dependencyMapping: false,
  artworkStatus: false,
  designJobs: false,
  files: false,
  capacityManagementDashboard: false,
  capacityManagementPlanning: false,
  capacityManagementBooking: false
};

const SearchFilterReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SHOW_SEARCH_FILTER:
      return { ...state, [action.page]: true };

    case types.HIDE_SEARCH_FILTER:
      return { ...state, [action.page]: false };

    case types.ALTER_SEARCH_FILTER:
      return { ...state, [action.page]: !state[action.page] };
      
    default:
      return state;
  }
};

export default SearchFilterReducer;
